define(['handlebars', 'i18next'], function(handlebars, i18next) {

	return function(countryCode) {

		var result = i18next.t('country:' + countryCode);
		return new handlebars.SafeString(result);
	}

});
